import FaIcon from '../common/FaIcon';

interface IconProps {
  className?: string;
  title?: string;
}

// A
export function AARIcon({ className, title }: IconProps) {
  return <FaIcon icon="clipboard-list" className={className} title={title} />;
}
export function AcademicCapIcon({ className, title }: IconProps) {
  return <FaIcon icon="graduation-cap" className={className} title={title} />;
}
export function ActivityLogIcon({ className, title }: IconProps) {
  return <FaIcon icon="clock-rotate-left" className={className} title={title} />;
}
export function AdminIcon({ className, title }: IconProps) {
  return <FaIcon icon="shield-halved" className={className} title={title} />;
}
export function AIIcon({ className, title }: IconProps) {
  return <FaIcon icon="sparkles" className={className} title={title} />;
}
export function AlertIcon({ className, title }: IconProps) {
  return <FaIcon icon="triangle-exclamation" className={className} title={title} />;
}
export function AlertTriangleIcon({ className, title }: IconProps) {
  return <FaIcon icon="triangle-exclamation" className={className} title={title} />;
}
export function ArchiveBoxIcon({ className, title }: IconProps) {
  return <FaIcon icon="box-archive" className={className} title={title} />;
}
export function ArrowDownIcon({ className, title }: IconProps) {
  return <FaIcon icon="arrow-down" className={className} title={title} />;
}
export function ArrowDownTrayIcon({ className, title }: IconProps) {
  return <FaIcon icon="download" className={className} title={title} />;
}
export function ArrowLeftIcon({ className, title }: IconProps) {
  return <FaIcon icon="arrow-left" className={className} title={title} />;
}
export function ArrowLeftOnRectangleIcon({ className, title }: IconProps) {
  return <FaIcon icon="right-to-bracket" className={className} title={title} />;
}
export function ArrowPathIcon({ className, title }: IconProps) {
  return <FaIcon icon="arrows-rotate" className={className} title={title} />;
}
export function ArrowRightIcon({ className, title }: IconProps) {
  return <FaIcon icon="arrow-right" className={className} title={title} />;
}
export function ArrowRightOnRectangleIcon({ className, title }: IconProps) {
  return <FaIcon icon="right-from-bracket" className={className} title={title} />;
}
export function ArrowTopRightOnSquareIcon({ className, title }: IconProps) {
  return <FaIcon icon="up-right-from-square" className={className} title={title} />;
}
export function ArrowTrendingDownIcon({ className, title }: IconProps) {
  return <FaIcon icon="arrow-trend-down" className={className} title={title} />;
}
export function ArrowTrendingUpIcon({ className, title }: IconProps) {
  return <FaIcon icon="arrow-trend-up" className={className} title={title} />;
}
export function ArrowUpIcon({ className, title }: IconProps) {
  return <FaIcon icon="arrow-up" className={className} title={title} />;
}
export function ArrowUpTrayIcon({ className, title }: IconProps) {
  return <FaIcon icon="cloud-arrow-up" className={className} title={title} />;
}
export function ArrowUturnLeftIcon({ className, title }: IconProps) {
  return <FaIcon icon="rotate-left" className={className} title={title} />;
}
export function ArrowsPointingOutIcon({ className, title }: IconProps) {
  return <FaIcon icon="up-down-left-right" className={className} title={title} />;
}
export function ArrowsRightLeftIcon({ className, title }: IconProps) {
  return <FaIcon icon="arrows-left-right" className={className} title={title} />;
}
export function AtRiskIcon({ className, title }: IconProps) {
  return <FaIcon icon="heart" className={className} title={title} />;
}
export function AuditIcon({ className, title }: IconProps) {
  return <FaIcon icon="file-shield" className={className} title={title} />;
}
export function AutomationIcon({ className, title }: IconProps) {
  return <FaIcon icon="bolt" className={className} title={title} />;
}

// B
export function BackwardIcon({ className, title }: IconProps) {
  return <FaIcon icon="backward" className={className} title={title} />;
}
export function Bars3Icon({ className, title }: IconProps) {
  return <FaIcon icon="bars" className={className} title={title} />;
}
export function BellAlertIcon({ className, title }: IconProps) {
  return <FaIcon icon="bell" className={className} title={title} />;
}
export function BellIcon({ className, title }: IconProps) {
  return <FaIcon icon="bell" className={className} title={title} />;
}
export function BoardIcon({ className, title }: IconProps) {
  return <FaIcon icon="clipboard-list" className={className} title={title} />;
}
export function BoxOpenIcon({ className, title }: IconProps) {
  return <FaIcon icon="box-open" className={className} title={title} />;
}
export function BoltIcon({ className, title }: IconProps) {
  return <FaIcon icon="bolt" className={className} title={title} />;
}
export function BookmarkIcon({ className, title }: IconProps) {
  return <FaIcon icon="bookmark" className={className} title={title} />;
}
export function BuildingIcon({ className, title }: IconProps) {
  return <FaIcon icon="building" className={className} title={title} />;
}
export function BuildingOffice2Icon({ className, title }: IconProps) {
  return <FaIcon icon="building-columns" className={className} title={title} />;
}
export function BuildingOfficeIcon({ className, title }: IconProps) {
  return <FaIcon icon="building" className={className} title={title} />;
}
export function BusinessIcon({ className, title }: IconProps) {
  return <FaIcon icon="store" className={className} title={title} />;
}

// C
export function CalendarIcon({ className, title }: IconProps) {
  return <FaIcon icon="calendar" className={className} title={title} />;
}
export function CameraIcon({ className, title }: IconProps) {
  return <FaIcon icon="camera" className={className} title={title} />;
}
export function CardViewIcon({ className, title }: IconProps) {
  return <FaIcon icon="table-cells" className={className} title={title} />;
}
export function ChartBarIcon({ className, title }: IconProps) {
  return <FaIcon icon="chart-bar" className={className} title={title} />;
}
export function ChartLineIcon({ className, title }: IconProps) {
  return <FaIcon icon="chart-line" className={className} title={title} />;
}
export function ChatBubbleLeftIcon({ className, title }: IconProps) {
  return <FaIcon icon="comment" className={className} title={title} />;
}
export function CheckBadgeIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-check" className={className} title={title} />;
}
export function CheckCircleIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-check" className={className} title={title} />;
}
export function CheckIcon({ className, title }: IconProps) {
  return <FaIcon icon="check" className={className} title={title} />;
}
export function ChevronDownIcon({ className, title }: IconProps) {
  return <FaIcon icon="chevron-down" className={className} title={title} />;
}
export function ChevronLeftIcon({ className, title }: IconProps) {
  return <FaIcon icon="chevron-left" className={className} title={title} />;
}
export function ChevronRightIcon({ className, title }: IconProps) {
  return <FaIcon icon="chevron-right" className={className} title={title} />;
}
export function ChevronUpIcon({ className, title }: IconProps) {
  return <FaIcon icon="chevron-up" className={className} title={title} />;
}
export function CircleStackIcon({ className, title }: IconProps) {
  return <FaIcon icon="database" className={className} title={title} />;
}
export function ClipboardCheckIcon({ className, title }: IconProps) {
  return <FaIcon icon="clipboard-check" className={className} title={title} />;
}
export function ClipboardDocIcon({ className, title }: IconProps) {
  return <FaIcon icon="clipboard-list" className={className} title={title} />;
}
export function ClipboardDocumentCheckIcon({ className, title }: IconProps) {
  return <FaIcon icon="clipboard-check" className={className} title={title} />;
}
export function ClipboardDocumentIcon({ className, title }: IconProps) {
  return <FaIcon icon="clipboard" className={className} title={title} />;
}
export function ClipboardDocumentListIcon({ className, title }: IconProps) {
  return <FaIcon icon="clipboard-list" className={className} title={title} />;
}
export function ClipboardIcon({ className, title }: IconProps) {
  return <FaIcon icon="clipboard" className={className} title={title} />;
}
export function ClipboardListIcon({ className, title }: IconProps) {
  return <FaIcon icon="clipboard-list" className={className} title={title} />;
}
export function ClockIcon({ className, title }: IconProps) {
  return <FaIcon icon="clock" className={className} title={title} />;
}
export function CloudIcon({ className, title }: IconProps) {
  return <FaIcon icon="cloud" className={className} title={title} />;
}
export function Cog6ToothIcon({ className, title }: IconProps) {
  return <FaIcon icon="gear" className={className} title={title} />;
}
export function ComputerIcon({ className, title }: IconProps) {
  return <FaIcon icon="desktop" className={className} title={title} />;
}
export function ContactsIcon({ className, title }: IconProps) {
  return <FaIcon icon="address-card" className={className} title={title} />;
}
export function CoopIcon({ className, title }: IconProps) {
  return <FaIcon icon="shield-halved" className={className} title={title} />;
}
export function CreateIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-plus" className={className} title={title} />;
}
export function CredentialsIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-user" className={className} title={title} />;
}
export function CriticalInfraIcon({ className, title }: IconProps) {
  return <FaIcon icon="building-columns" className={className} title={title} />;
}
export function CubeIcon({ className, title }: IconProps) {
  return <FaIcon icon="cube" className={className} title={title} />;
}

// D
export function DollarSignIcon({ className, title }: IconProps) {
  return <FaIcon icon="dollar-sign" className={className} title={title} />;
}

export function DamageAssessmentIcon({ className, title }: IconProps) {
  return <FaIcon icon="clipboard-check" className={className} title={title} />;
}
export function DamageIcon({ className, title }: IconProps) {
  return <FaIcon icon="clipboard-check" className={className} title={title} />;
}
export function DeviceTabletIcon({ className, title }: IconProps) {
  return <FaIcon icon="tablet" className={className} title={title} />;
}
export function DocumentArrowDownIcon({ className, title }: IconProps) {
  return <FaIcon icon="file-arrow-down" className={className} title={title} />;
}
export function DocumentDuplicateIcon({ className, title }: IconProps) {
  return <FaIcon icon="copy" className={className} title={title} />;
}
export function DocumentIcon({ className, title }: IconProps) {
  return <FaIcon icon="file-lines" className={className} title={title} />;
}
export function DocumentTextIcon({ className, title }: IconProps) {
  return <FaIcon icon="file-lines" className={className} title={title} />;
}
export function DownloadIcon({ className, title }: IconProps) {
  return <FaIcon icon="download" className={className} title={title} />;
}
export function DroneIcon({ className, title }: IconProps) {
  return <FaIcon icon="drone" className={className} title={title} />;
}
export function DropletIcon({ className, title }: IconProps) {
  return <FaIcon icon="droplet" className={className} title={title} />;
}

// E
export function ElectricIcon({ className, title }: IconProps) {
  return <FaIcon icon="plug" className={className} title={title} />;
}
export function EllipsisHorizontalIcon({ className, title }: IconProps) {
  return <FaIcon icon="ellipsis" className={className} title={title} />;
}
export function EllipsisIcon({ className, title }: IconProps) {
  return <FaIcon icon="ellipsis-vertical" className={className} title={title} />;
}
export function EllipsisVerticalIcon({ className, title }: IconProps) {
  return <FaIcon icon="ellipsis-vertical" className={className} title={title} />;
}
export function EnvelopeIcon({ className, title }: IconProps) {
  return <FaIcon icon="envelope" className={className} title={title} />;
}
export function EvacuationIcon({ className, title }: IconProps) {
  return <FaIcon icon="person-running" className={className} title={title} />;
}
export function ExclamationCircleIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-exclamation" className={className} title={title} />;
}
export function ExclamationTriangleIcon({ className, title }: IconProps) {
  return <FaIcon icon="triangle-exclamation" className={className} title={title} />;
}
export function ExternalLinkIcon({ className, title }: IconProps) {
  return <FaIcon icon="up-right-from-square" className={className} title={title} />;
}
export function EyeIcon({ className, title }: IconProps) {
  return <FaIcon icon="eye" className={className} title={title} />;
}

// F
export function FileInvoiceDollarIcon({ className, title }: IconProps) {
  return <FaIcon icon="file-invoice-dollar" className={className} title={title} />;
}

export function FanIcon({ className, title }: IconProps) {
  return <FaIcon icon="compass" className={className} title={title} />;
}
export function FieldIcon({ className, title }: IconProps) {
  return <FaIcon icon="location-dot" className={className} title={title} />;
}
export function FieldOpsIcon({ className, title }: IconProps) {
  return <FaIcon icon="location-dot" className={className} title={title} />;
}
export function FileLibraryIcon({ className, title }: IconProps) {
  return <FaIcon icon="folder-open" className={className} title={title} />;
}
export function FireIcon({ className, title }: IconProps) {
  return <FaIcon icon="fire" className={className} title={title} />;
}
export function FlagIcon({ className, title }: IconProps) {
  return <FaIcon icon="flag" className={className} title={title} />;
}
export function FlameIcon({ className, title }: IconProps) {
  return <FaIcon icon="fire" className={className} title={title} />;
}
export function FloodIcon({ className, title }: IconProps) {
  return <FaIcon icon="water" className={className} title={title} />;
}
export function FormIcon({ className, title }: IconProps) {
  return <FaIcon icon="file-lines" className={className} title={title} />;
}
export function ForwardIcon({ className, title }: IconProps) {
  return <FaIcon icon="forward" className={className} title={title} />;
}
export function FoundationIcon({ className, title }: IconProps) {
  return <FaIcon icon="house-crack" className={className} title={title} />;
}
export function FunnelIcon({ className, title }: IconProps) {
  return <FaIcon icon="filter" className={className} title={title} />;
}

// G
export function GasIcon({ className, title }: IconProps) {
  return <FaIcon icon="fire-flame-simple" className={className} title={title} />;
}
export function GlobeAltIcon({ className, title }: IconProps) {
  return <FaIcon icon="globe" className={className} title={title} />;
}
export function GlobeIcon({ className, title }: IconProps) {
  return <FaIcon icon="globe" className={className} title={title} />;
}

// H
export function HazmatIcon({ className, title }: IconProps) {
  return <FaIcon icon="biohazard" className={className} title={title} />;
}
export function HeartIcon({ className, title }: IconProps) {
  return <FaIcon icon="heart" className={className} title={title} />;
}
export function HelpIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-question" className={className} title={title} />;
}
export function HomeIcon({ className, title }: IconProps) {
  return <FaIcon icon="house" className={className} title={title} />;
}
export function HandshakeIcon({ className, title }: IconProps) {
  return <FaIcon icon="handshake" className={className} title={title} />;
}

// I
export function InboxIcon({ className, title }: IconProps) {
  return <FaIcon icon="inbox" className={className} title={title} />;
}
export function InformationCircleIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-info" className={className} title={title} />;
}
export function InfraIcon({ className, title }: IconProps) {
  return <FaIcon icon="building-columns" className={className} title={title} />;
}
export function InventoryIcon({ className, title }: IconProps) {
  return <FaIcon icon="box-archive" className={className} title={title} />;
}

// K
export function KeyboardIcon({ className, title }: IconProps) {
  return <FaIcon icon="keyboard" className={className} title={title} />;
}

// L
export function LayersIcon({ className, title }: IconProps) {
  return <FaIcon icon="layer-group" className={className} title={title} />;
}
export function LifelinesIcon({ className, title }: IconProps) {
  return <FaIcon icon="shield-halved" className={className} title={title} />;
}
export function LinkIcon({ className, title }: IconProps) {
  return <FaIcon icon="link" className={className} title={title} />;
}
export function ListIcon({ className, title }: IconProps) {
  return <FaIcon icon="list" className={className} title={title} />;
}
export function ListViewIcon({ className, title }: IconProps) {
  return <FaIcon icon="list" className={className} title={title} />;
}
export function LockClosedIcon({ className, title }: IconProps) {
  return <FaIcon icon="lock" className={className} title={title} />;
}
export function LogoutIcon({ className, title }: IconProps) {
  return <FaIcon icon="right-from-bracket" className={className} title={title} />;
}

// M
export function MagnifyingGlassIcon({ className, title }: IconProps) {
  return <FaIcon icon="magnifying-glass" className={className} title={title} />;
}
export function MapIcon({ className, title }: IconProps) {
  return <FaIcon icon="map" className={className} title={title} />;
}
export function MapPinIcon({ className, title }: IconProps) {
  return <FaIcon icon="location-dot" className={className} title={title} />;
}
export function MenuIcon({ className, title }: IconProps) {
  return <FaIcon icon="bars" className={className} title={title} />;
}
export function MicrophoneIcon({ className, title }: IconProps) {
  return <FaIcon icon="microphone" className={className} title={title} />;
}
export function MinusCircleIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-minus" className={className} title={title} />;
}
export function MinusIcon({ className, title }: IconProps) {
  return <FaIcon icon="minus" className={className} title={title} />;
}
export function MoonIcon({ className, title }: IconProps) {
  return <FaIcon icon="moon" className={className} title={title} />;
}

// N
export function NoSymbolIcon({ className, title }: IconProps) {
  return <FaIcon icon="ban" className={className} title={title} />;
}
export function NotificationIcon({ className, title }: IconProps) {
  return <FaIcon icon="bell" className={className} title={title} />;
}

// P
export function PaperAirplaneIcon({ className, title }: IconProps) {
  return <FaIcon icon="paper-plane" className={className} title={title} />;
}
export function PaperClipIcon({ className, title }: IconProps) {
  return <FaIcon icon="paperclip" className={className} title={title} />;
}
export function PauseIcon({ className, title }: IconProps) {
  return <FaIcon icon="pause" className={className} title={title} />;
}
export function PencilIcon({ className, title }: IconProps) {
  return <FaIcon icon="pen-to-square" className={className} title={title} />;
}
export function PencilSquareIcon({ className, title }: IconProps) {
  return <FaIcon icon="pen-to-square" className={className} title={title} />;
}
export function HeadsetIcon({ className, title }: IconProps) {
  return <FaIcon icon="headset" className={className} title={title} />;
}
export function PhoneIcon({ className, title }: IconProps) {
  return <FaIcon icon="phone" className={className} title={title} />;
}
export function PhotoIcon({ className, title }: IconProps) {
  return <FaIcon icon="image" className={className} title={title} />;
}
export function PinIcon({ className, title }: IconProps) {
  return <FaIcon icon="thumbtack" className={className} title={title} />;
}
export function PlayIcon({ className, title }: IconProps) {
  return <FaIcon icon="play" className={className} title={title} />;
}
export function PlusCircleIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-plus" className={className} title={title} />;
}
export function PlusIcon({ className, title }: IconProps) {
  return <FaIcon icon="plus" className={className} title={title} />;
}

// Q
export function QrCodeIcon({ className, title }: IconProps) {
  return <FaIcon icon="qrcode" className={className} title={title} />;
}

// R
export function ReceiptIcon({ className, title }: IconProps) {
  return <FaIcon icon="receipt" className={className} title={title} />;
}
export function RefreshIcon({ className, title }: IconProps) {
  return <FaIcon icon="arrows-rotate" className={className} title={title} />;
}
export function ResourcesIcon({ className, title }: IconProps) {
  return <FaIcon icon="truck-ramp-box" className={className} title={title} />;
}
export function RoadIcon({ className, title }: IconProps) {
  return <FaIcon icon="road-barrier" className={className} title={title} />;
}
export function RocketIcon({ className, title }: IconProps) {
  return <FaIcon icon="rocket" className={className} title={title} />;
}
export function RocketLaunchIcon({ className, title }: IconProps) {
  return <FaIcon icon="rocket" className={className} title={title} />;
}
export function RoofIcon({ className, title }: IconProps) {
  return <FaIcon icon="house-chimney-crack" className={className} title={title} />;
}

// S
export function SearchIcon({ className, title }: IconProps) {
  return <FaIcon icon="magnifying-glass" className={className} title={title} />;
}
export function SortIcon({ className, title }: IconProps) {
  return <FaIcon icon="arrow-up-arrow-down" className={className} title={title} />;
}
export function SettingsIcon({ className, title }: IconProps) {
  return <FaIcon icon="gear" className={className} title={title} />;
}
export function SewerIcon({ className, title }: IconProps) {
  return <FaIcon icon="pipe-circle-check" className={className} title={title} />;
}
export function ShareIcon({ className, title }: IconProps) {
  return <FaIcon icon="share-nodes" className={className} title={title} />;
}
export function ShelterIcon({ className, title }: IconProps) {
  return <FaIcon icon="house-chimney" className={className} title={title} />;
}
export function ShieldCheckIcon({ className, title }: IconProps) {
  return <FaIcon icon="shield" className={className} title={title} />;
}
export function ShieldIcon({ className, title }: IconProps) {
  return <FaIcon icon="shield" className={className} title={title} />;
}
export function SignalIcon({ className, title }: IconProps) {
  return <FaIcon icon="signal" className={className} title={title} />;
}
export function SparklesIcon({ className, title }: IconProps) {
  return <FaIcon icon="sparkles" className={className} title={title} />;
}
export function SpinnerIcon({ className, title }: IconProps) {
  return <FaIcon icon="spinner" className={className} title={title} />;
}
export function Squares2X2Icon({ className, title }: IconProps) {
  return <FaIcon icon="table-cells" className={className} title={title} />;
}
export function StopIcon({ className, title }: IconProps) {
  return <FaIcon icon="stop" className={className} title={title} />;
}
export function SunIcon({ className, title }: IconProps) {
  return <FaIcon icon="sun" className={className} title={title} />;
}
export function SwatchIcon({ className, title }: IconProps) {
  return <FaIcon icon="palette" className={className} title={title} />;
}

// T
export function TagIcon({ className, title }: IconProps) {
  return <FaIcon icon="tag" className={className} title={title} />;
}
export function TaskIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-check" className={className} title={title} />;
}
export function TelecomIcon({ className, title }: IconProps) {
  return <FaIcon icon="tower-cell" className={className} title={title} />;
}
export function TimerIcon({ className, title }: IconProps) {
  return <FaIcon icon="clock" className={className} title={title} />;
}
/** W13-DEBRIS: debris estimates (FEMA Category A). */
export function DebrisIcon({ className, title }: IconProps) {
  return <FaIcon icon="dumpster" className={className} title={title} />;
}
export function TrashIcon({ className, title }: IconProps) {
  return <FaIcon icon="trash-can" className={className} title={title} />;
}
export function TrophyIcon({ className, title }: IconProps) {
  return <FaIcon icon="trophy" className={className} title={title} />;
}
export function TruckIcon({ className, title }: IconProps) {
  return <FaIcon icon="truck" className={className} title={title} />;
}

// U
export function UploadIcon({ className, title }: IconProps) {
  return <FaIcon icon="cloud-arrow-up" className={className} title={title} />;
}
export function UserCircleIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-user" className={className} title={title} />;
}
export function UserGroupIcon({ className, title }: IconProps) {
  return <FaIcon icon="users" className={className} title={title} />;
}
export function UserIcon({ className, title }: IconProps) {
  return <FaIcon icon="user" className={className} title={title} />;
}
export function UserMinusIcon({ className, title }: IconProps) {
  return <FaIcon icon="user-minus" className={className} title={title} />;
}
export function UserPlusIcon({ className, title }: IconProps) {
  return <FaIcon icon="user-plus" className={className} title={title} />;
}
export function UsersIcon({ className, title }: IconProps) {
  return <FaIcon icon="users" className={className} title={title} />;
}
export function UtensilsIcon({ className, title }: IconProps) {
  return <FaIcon icon="utensils" className={className} title={title} />;
}
export function UtilityIcon({ className, title }: IconProps) {
  return <FaIcon icon="bolt" className={className} title={title} />;
}

// V
export function VideoCameraIcon({ className, title }: IconProps) {
  return <FaIcon icon="video" className={className} title={title} />;
}

// W
export function WallIcon({ className, title }: IconProps) {
  return <FaIcon icon="bars" className={className} title={title} />;
}
export function WarehouseIcon({ className, title }: IconProps) {
  return <FaIcon icon="warehouse" className={className} title={title} />;
}
export function WaterDropIcon({ className, title }: IconProps) {
  return <FaIcon icon="droplet" className={className} title={title} />;
}
export function WaterIcon({ className, title }: IconProps) {
  return <FaIcon icon="faucet-drip" className={className} title={title} />;
}
export function WeatherIcon({ className, title }: IconProps) {
  return <FaIcon icon="cloud-sun" className={className} title={title} />;
}
export function WindowIcon({ className, title }: IconProps) {
  return <FaIcon icon="window-maximize" className={className} title={title} />;
}
export function WrenchIcon({ className, title }: IconProps) {
  return <FaIcon icon="wrench" className={className} title={title} />;
}
export function WrenchScrewdriverIcon({ className, title }: IconProps) {
  return <FaIcon icon="wrench" className={className} title={title} />;
}

// P (additional)
export function PIOIcon({ className, title }: IconProps) {
  return <FaIcon icon="bullhorn" className={className} title={title} />;
}

// X
export function XCircleIcon({ className, title }: IconProps) {
  return <FaIcon icon="circle-xmark" className={className} title={title} />;
}
export function XMarkIcon({ className, title }: IconProps) {
  return <FaIcon icon="xmark" className={className} title={title} />;
}
